import React, { useEffect } from "react";
import DocWrapper from "../DocWrapper";
import docStyles from "../../../css/Docs/Docs.module.css";
import { Divider } from "@mui/material";
import CodeBlock from "../CodeBlock";
import { Link } from "react-router-dom";

const PendingDemandsVendors = () => {
  useEffect(() => {
    const el = document.getElementById("introduction");
    if (el) {
      el.scrollIntoView();
    }
  }, []);

  const curlSample = `
~~~curl
curl --location 'https://test.eqlfin.com/office/{{OFFICE_ID}}/pendingDemandsForVendor' 
--header 'Firebase-Env: env/core' 
--header 'Authorization: Basic {{BASIC_TOKEN}}
~~~
    `;

  return (
    <DocWrapper>
      <div className={docStyles.container}>
        <section id="introduction" className={docStyles.section}>
          <div className={docStyles.heading}>Introduction</div>
          <div className={docStyles.para}>
            This endpoint of Office API retrieves the pending demands for all
            vendors in an office identified by OFFICE_ID.
          </div>
        </section>

        <br />
        <Divider sx={{ width: "100%" }} />

        <section id="fields" className={docStyles.section}>
          <div className={docStyles.heading}>Important Fields</div>
          <div className={docStyles.para}>
            To properly interact with the Offices, the following fields are
            important:
            <ul
              style={{
                padding: "0px 0px 5px 10px",
                margin: "5px 0px 5px 10px",
              }}
            >
              <li>officeId</li>
            </ul>
          </div>
        </section>

        <br />
        <Divider sx={{ width: "100%" }} />

        <section id="request-example" className={docStyles.section}>
          <div className={docStyles.heading}>Request Example</div>
          <div className={docStyles.para}>
            Type: <b>GET</b>
          </div>

          <div className={docStyles.para}>
            To retrieve the pending demands for vendor in the specified office,
            you can use the following curl command:
            <CodeBlock codeMarkdown={curlSample} />
          </div>

          <div className={docStyles.para}>
            Please make sure to replace <b> OFFICE_ID </b> in the URL with the
            actual office identifier. <br /> Additionally, replace{" "}
            <b> BASIC_TOKEN </b>
            in the Authorization header with the appropriate token for
            authentication.
          </div>

          <br />
          <Divider sx={{ width: "100%" }} />

          <section id="response" className={docStyles.section}>
            <div className={docStyles.heading}>Response</div>
            <div className={docStyles.para}>
              Upon a successful request, the API will respond with the following
              information:
            </div>

            {/* <div className={docStyles.subHeading}>201 - Created</div> */}
            <CodeBlock
              codeMarkdown={`
~~~json
{
"demands": [
    {
        "isInvoiceApproved": false,
        "paymentDate": null,
        "dueDate": 1685890051000,
        "invoiceDateTimestamp": 1672511400000,
        "billingBranch": "VILLAGE MAHIPAL PUR SEHRAWAT TRANSPORT SERVICE",
        "tds": [],
        "documentNumber": "13062001",
        "billingCustomer": "New Delhi GROWTHFILE ANALYTICS PRIVATE LIMITED",
        "paidAmount": 385860,
        "pendingAmount": 594140,
        "totalAmount": 1036000,
        "tdsAmount": 20000,
        "cgstAmount": 18000,
        "igstAmount": 0,
        "sgstAmount": 18000,
        "demandId": "WnpULEAnAFRKR8rQXKE0",
        "customerOfficeId": "m6FVT0kyUTSdSdtQYi9f",
        "sellerOfficeId": "NZecvOdAuUfso1WOjM3j",
        "customerOffice": "GROWTHFILE ANALYTICS PRIVATE LIMITED",
        "sellerOffice": "SEHRAWAT TRANSPORT SERVICE",
        "customerGst": "06AAHCG1096G1Z9",
        "sellerGst": "06APTP12680G1ZD",
        "branchLogo": null
    },
        ]
}
~~~
    `}
            />
          </section>

          <Divider sx={{ width: "100%" }} />
          {/* <section id="error" className={docStyles.section}>
            <div className={docStyles.heading}>Error Responses</div>

            <div className={docStyles.para}>
              In case of errors during the API call, you may receive one of the
              following error responses:
              <ul
                style={{
                  padding: "0px 0px 5px 10px",
                  margin: "5px 0px 5px 10px",
                }}
              >
                <li>
                  <b>Unauthorized Error: </b> Occurs when the request lacks
                  valid authentication or authorization credentials.
                </li>
                <li>
                  <b> Server Error: </b> Indicates an unexpected error on the
                  server side, such as a database connection issue or an
                  unhandled exception.
                </li>
              </ul>
            </div>

            <div className={docStyles.subHeading}>400 - Bad Request</div>
            <CodeBlock
              codeMarkdown={`
    ~~~json
    {
        "message": "the field of type 'gst-office' must belong to the requesting office only",
        "success": false,
        "code": 400
    }
    ~~~
    `}
            />
          </section> */}
        </section>
      </div>
      <section className={docStyles.tableOfContentSection}>
        <div className={docStyles.tableOfContent}>
          <div className={docStyles.tocHeading}>Table of contents</div>
          <ul className={docStyles.tocList}>
            <li>
              <Link to="#introduction">Introduction</Link>
            </li>
            <li>
              <Link to="#fields">Important Fields</Link>
            </li>
            <li>
              <Link to="#request-example">Request Example</Link>
            </li>
            <li>
              <Link to="#response">Response</Link>
            </li>
            {/* <li>
              <Link to="#error">Error Response</Link>
            </li> */}
          </ul>
        </div>
      </section>
    </DocWrapper>
  );
};

export default PendingDemandsVendors;
